/**
 * @generated SignedSource<<a0396ea6cfbfaa395e3f37b62cdcc032>>
 * @relayHash 8e1016e145836c87173ea3f3316288db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba91d40da0be32868877e278a281b9d6ccc974412a22f2ffa6557fc08de21ec9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessAttachmentsQuery } from './src_jiraBusinessAttachmentsQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessAttachmentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ba91d40da0be32868877e278a281b9d6ccc974412a22f2ffa6557fc08de21ec9",
    "metadata": {},
    "name": "src_jiraBusinessAttachmentsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
